module.exports = __webpack_public_path__ + "img/clouds-sun-light.f9c0c0f7.svg";